export const MEASUREMENT_CALCULATION_TYPE_TOTAL_COUNT = 1;
export const MEASUREMENT_CALCULATION_TYPE_PERCENTAGE = 2;
export const MEASUREMENT_CALCULATION_TYPE_RATE = 3;
export const MEASUREMENT_CALCULATION_TYPE_RATIO = 4;
